/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Offer = {

	delete (context, offerId, onSuccess, onError, options) {
		Api.delete(context,
			"/offer"
			+ "?offerId=" + offerId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllBidderNames (context, onSuccess, onError, options) {
		Api.get(context,
			"/offer/all-bidder-names"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllContestNames (context, onlyMine, onSuccess, onError, options) {
		Api.get(context,
			"/offer/all-contest-names"
			+ "?onlyMine=" + onlyMine
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllOffersNamesAndCodes (context, onSuccess, onError, options) {
		Api.get(context,
			"/offer/all-offers-names-and-codes"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllowedBasicData (context, onSuccess, onError, options) {
		Api.get(context,
			"/offer/allowed-basic-data"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAvailableOfferMutualBidders (context, offerId, onSuccess, onError, options) {
		Api.get(context,
			"/offer/available-offer-mutual-bidders"
			+ "?offerId=" + offerId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBasicData (context, offerId, onSuccess, onError, options) {
		Api.get(context,
			"/offer/basic-data"
			+ "?offerId=" + offerId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBasicDataByCode (context, code, onSuccess, onError, options) {
		Api.get(context,
			"/offer/basic-data-by-code"
			+ "?code=" + code
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBasicDataList (context, ids, onSuccess, onError, options) {
		Api.get(context,
			"/offer/basic-data-list"
			+ "?ids=" + ids
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBidderFundings (context, offerId, module, onSuccess, onError, options) {
		Api.get(context,
			"/offer/bidder-fundings"
			+ "?offerId=" + offerId
			+ "&module=" + module
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBidderOfferList (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/offer/bidder-offer-list"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBidderOffersCorrectionCauses (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/offer/bidder-offers-correction-causes"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBiddersContestNames (context, bidderId, onSuccess, onError, options) {
		Api.get(context,
			"/offer/bidders-contest-names"
			+ "?bidderId=" + bidderId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCompareData (context, offerId, firstVersion, secondVersion, onSuccess, onError, options) {
		Api.get(context,
			"/offer/compare-data"
			+ "?offerId=" + offerId
			+ "&firstVersion=" + firstVersion
			+ "&secondVersion=" + secondVersion
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCopyModuleActionsAndCostPossibilities (context, offerId, moduleNumber, onSuccess, onError, options) {
		Api.get(context,
			"/offer/copy-module-actions-and-cost-possibilities"
			+ "?offerId=" + offerId
			+ "&moduleNumber=" + moduleNumber
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCorrectionHistory (context, offerId, onSuccess, onError, options) {
		Api.get(context,
			"/offer/correction-history"
			+ "?offerId=" + offerId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getData (context, offerId, onSuccess, onError, options) {
		Api.get(context,
			"/offer/data"
			+ "?offerId=" + offerId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDataReadonly (context, offerId, onSuccess, onError, options) {
		Api.get(context,
			"/offer/data-readonly"
			+ "?offerId=" + offerId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDataVersion (context, offerId, version, onSuccess, onError, options) {
		Api.get(context,
			"/offer/data-version"
			+ "?offerId=" + offerId
			+ "&version=" + version
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFinalEvaluationId (context, offerId, onSuccess, onError, options) {
		Api.get(context,
			"/offer/final-evaluation-id"
			+ "?offerId=" + offerId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getOfferPrioritiesSummary (context, offerId, version, onSuccess, onError, options) {
		Api.get(context,
			"/offer/offer-priorities-summary"
			+ "?offerId=" + offerId
			+ "&version=" + version
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSubmittedOfferList (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/offer/submitted-offer-list"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSubmittedOfferListForSystemRole (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/offer/submitted-offer-list-for-system-role"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSubmittedOffersCorrectionCauses (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/offer/submitted-offers-correction-causes"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, createOfferDto, onSuccess, onError, options) {
		Api.post(context,
			"/offer"
			, createOfferDto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAccept (context, offerDataId, onSuccess, onError, options) {
		Api.post(context,
			"/offer/accept"
			+ "?offerDataId=" + offerDataId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAcceptSubbidderOffer (context, offerId, onSuccess, onError, options) {
		Api.post(context,
			"/offer/accept-subbidder-offer"
			+ "?offerId=" + offerId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postComplete (context, offerId, onSuccess, onError, options) {
		Api.post(context,
			"/offer/complete"
			+ "?offerId=" + offerId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postGivePrivillages (context, offerId, userId, onSuccess, onError, options) {
		Api.post(context,
			"/offer/give-privillages"
			+ "?offerId=" + offerId
			+ "&userId=" + userId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postReject (context, offerId, rejectCauseDTO, onSuccess, onError, options) {
		Api.post(context,
			"/offer/reject"
			+ "?offerId=" + offerId
			, rejectCauseDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postRejectMutualOffer (context, offerDataId, onSuccess, onError, options) {
		Api.post(context,
			"/offer/reject-mutual-offer"
			+ "?offerDataId=" + offerDataId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postRejectSubbidderOffer (context, offerId, onSuccess, onError, options) {
		Api.post(context,
			"/offer/reject-subbidder-offer"
			+ "?offerId=" + offerId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postSubmit (context, offerId, onSuccess, onError, options) {
		Api.post(context,
			"/offer/submit"
			+ "?offerId=" + offerId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, offerId, offerData, onSuccess, onError, options) {
		Api.put(context,
			"/offer"
			+ "?offerId=" + offerId
			, offerData
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putApprove (context, offerId, onSuccess, onError, options) {
		Api.put(context,
			"/offer/approve"
			+ "?offerId=" + offerId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putCopyModuleActionsAndCosts (context, offerId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/offer/copy-module-actions-and-costs"
			+ "?offerId=" + offerId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putCostsShare (context, offerId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/offer/costs-share"
			+ "?offerId=" + offerId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putGenericModuleForm (context, offerId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/offer/generic-module-form"
			+ "?offerId=" + offerId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putGenericPersistentForm (context, offerId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/offer/generic-persistent-form"
			+ "?offerId=" + offerId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putMainData (context, offerId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/offer/main-data"
			+ "?offerId=" + offerId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putModuleActionsAndCosts (context, offerId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/offer/module-actions-and-costs"
			+ "?offerId=" + offerId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putModuleDatesAndVolunteers (context, offerId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/offer/module-dates-and-volunteers"
			+ "?offerId=" + offerId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putRequestCorrection (context, offerId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/offer/request-correction"
			+ "?offerId=" + offerId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putRestoreOffer (context, offerId, onSuccess, onError, options) {
		Api.put(context,
			"/offer/restore-offer"
			+ "?offerId=" + offerId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putStats (context, offerId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/offer/stats"
			+ "?offerId=" + offerId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putStep (context, offerId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/offer/step"
			+ "?offerId=" + offerId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoRequestCorrection (context, offerId, onSuccess, onError, options) {
		Api.put(context,
			"/offer/undo-request-correction"
			+ "?offerId=" + offerId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
